export const getTransactionTypeLabel = (type: string): string => {
  switch (type) {
    case 'sale':
      return 'Vente';
    case 'return':
      return 'Retour';
    case 'restock':
      return 'Réapprovisionnement';
    case 'loss':
      return 'Perte';
    case 'return_refund':
      return 'Remboursement retour';
    default:
      return type;
  }
};

export const getTransactionTypeColor = (type: string): string => {
  switch (type) {
    case 'sale':
      return 'text-green-600';
    case 'return':
    case 'return_refund':
      return 'text-red-600';
    case 'restock':
      return 'text-blue-600';
    case 'loss':
      return 'text-orange-600';
    default:
      return 'text-gray-600';
  }
};